import { SubscriptionWithoutWithScopesDto } from "@intelligems/ig-types";

const sortBy = (
  a: SubscriptionWithoutWithScopesDto,
  b: SubscriptionWithoutWithScopesDto
) => {
  return (
    b.defaultInterval.localeCompare(a.defaultInterval) ||
    a.defaultPrice - b.defaultPrice
  );
};

const getTrialExpDate = () => {
  const today = new Date();
  const expirationDate = new Date();
  return new Date(
    expirationDate.setDate(today.getDate() + 7)
  ).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

export { getTrialExpDate, sortBy };
